import {assert} from 'assert-ts';
import type {Schemas} from 'api/dto.generated';
import {CodeListRef} from 'schemas/references';
import type {Code, CodeList, CodeListId} from '../types';

export const mapCodeListDto = (dto: Schemas.CodelistDto): CodeList => {
  const codelist = {
    id: assert(dto.id, 'mapCodeListDto: dto.id is required'),
    language: dto.language,
    codes: assert(dto.codes, 'mapCodeListDto: dto.codes is required').map<Code>(
      ({code, value, deactivated, deprecated}) => ({
        code: assert(code, 'mapCodeListDto: dto.codes.code is required'),
        value: assert(value ?? code),
        deactivated: deactivated || deprecated,
      }),
    ),
  };

  return assertValidRefs(codelist);
};

const assertValidRefs = (codelist: CodeList): CodeList => {
  const refs =
    (CodeListRef as {[id in CodeListId]?: {[key in string]: string}})[
      codelist.id
    ] ?? {};
  Object.keys(refs).forEach(key => {
    assert(
      key.toLowerCase().startsWith('prefix_') ||
        codelist.codes.find(c => c.code === refs[key]),
      'Invalid codelist ref value',
      {ref: refs[key], codelistId: codelist.id, codes: codelist.codes},
    );
  });

  return codelist;
};
